import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import { App } from './App';
import { i18next, initI18n } from './i18n/init';

// i18next must be ready before any component reads `t(...)`. The init is
// sync (no async backend) — localStorage-cached bundle resolves
// synchronously and React renders with the right translations on the
// first paint. Background refresh from /api/i18n/v1/bundle still runs.
initI18n();

const container = document.getElementById('root');
if (!container) throw new Error('No #root element found in index.html');

createRoot(container).render(
  <StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </StrictMode>,
);

// Register the service worker only in production builds. Vite serves dev
// from memory and a stale SW would intercept HMR module requests, so the
// register call is gated behind PROD.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      console.warn('[sw] registration failed', err);
    });
  });
}
